"use client";

import DisplayImage from "@/components/common/DisplayImage";
import Link from "next/link";
import {
    Flex,
    Heading,
    Separator,
    variables,
} from "politicamente-informados-ds";
import React from "react";
import { styled } from "styled-components";

interface Party {
    title:
    | string
    | number
    | boolean
    | React.ReactElement
    | Iterable<React.ReactNode>
    | null
    | undefined;
    acf: {
        name?: string;
        url: string;
        logo: {
            url?: string;
        };
    };
}

interface Grid {
    items?: Party[];
}

interface Attrs {
    className?: string;
    style?: Record<string, unknown>;
    grid?: Grid;
}

interface IBlockPoliticalParties {
    attrs: Attrs;
}

const BlockPoliticalParties: React.FC<IBlockPoliticalParties> = ({ attrs }) => {
    const { grid } = attrs;
    return (
        <StyledContainer>
            <Flex direction="column" gap="16px">
                {grid?.items?.map((party) => (
                    <React.Fragment key={party.acf.url}>
                        <Link target="_blank" href={party.acf.url} className="w-100">
                            <Flex gap="24px" wrap="nowrap" className="w-100">
                                <DisplayImage
                                    alt={party?.acf?.name ?? ""}
                                    url={party?.acf.logo?.url ?? ""}
                                    width={90}
                                    height={100}
                                />
                                <Heading size="h3" tag="h3" className="flex-grow-1 fw-bold">
                                    {party.acf.name}
                                </Heading>
                            </Flex>
                        </Link>
                        <Separator height="1px" color={variables.colors.gray90} />
                    </React.Fragment>
                ))}
            </Flex>
        </StyledContainer>
    );
};

export default BlockPoliticalParties;

const StyledContainer = styled.div`
  transition: all 400ms;
  a {
    transition: all 300ms;
    &:hover {
      background-color: #f4f4f4;
      opacity: .9;
    }
  }
`;
